import {combineReducers} from 'redux'
import userReducer from './UserReducer'
import generalReducer from './GeneralReducer'

export default combineReducers({
    userState : userReducer,
    generalState : generalReducer,
})